import { getBooleanConfig } from '@zg-rentals/frontend-config/client';

// Datarouter frontend-config flag that drives IA nav rollout (ZRM-16458). camelCase
// per Datarouter convention (cf. canAccessUserManagement, canAccessFlexibleProperties).
// Owning service RMA, appName zillow-rental-manager-web-next.
export const IA_NAV_CONFIG_FLAG = 'canAccessIaNavigation';

// QA opt-in cookies for Test B. Both are duplicated in zrmw's FeatureFlagConstants, which is
// what puts them on the /featureFlags page — keep those in sync. Either one now opts into both
// the IA nav and the Listings entry point, since a single treatment drives both.
export const ZRM_IA_NAV_ENABLED = 'ZRM_IA_NAV_ENABLED';
export const ZRM_LISTING_LIST_ENABLED = 'ZRM_LISTING_LIST_ENABLED';

// Split owns Test B population targeting (ZRM-16713), so there is deliberately no
// frontend-config rollout flag in this gate.
export const LISTING_CENTRIC_VIEW_SPLIT_FEATURE_NAME = 'zrm_listing_list_page';

// SSR-safe boolean cookie reader. Mirrors zrmw's getCookieAsBoolean: a value of
// 'true' or '1' is truthy. Returns false on the server (no document).
export function getCookieAsBoolean(name: string) {
  if (typeof document === 'undefined') return false;

  const match = document.cookie.split('; ').find((c) => c.startsWith(name + '='));
  if (!match) return false;

  const value = match.slice(name.length + 1);

  return value === 'true' || value === '1';
}

// TODO ZRM-17029: drop once canAccessIaNavigation is confirmed at 0% rollout. The IA nav is
// gated on the Test B treatment now; this stays OR'd in so anyone the Datarouter flag already
// turned it on for does not lose it mid-transition. Client-only (call after mount).
export function getLegacyIaNavConfigEnabled() {
  return getBooleanConfig(IA_NAV_CONFIG_FLAG, false);
}
